import React, { useState } from "react";
import { getImageUrl } from "../../../utils/images";
import { FormsTabs } from "./FormsTabs.Component";
import { ShowMigrateduserDetails } from "../../Pages/ShowMigrateduserDetails.Page";
import { UserMigratedDetails } from "../../Pages/UserMigratedDetails";
import { useDispatch, useSelector } from "react-redux";
import { isEmail, isPhoneNumber } from "../../../helpers/string";
import { PasswordVerification } from "../../Pages/PasswordVerification";
import { ReviewDetailsForm } from "../../Pages/ReviewDetailsForm.Component";
import { userActions } from "../../../store/userState";
import { submitUserform } from "../../../service/BrandsService";
import { showMessage, showSpinner } from "../../../utils/alerts";
import Swal from "sweetalert2";
import { SuccessActionModal } from "../../Modals/UploadDocument/SuccessActionModal.Modal";
import { formatDate } from "../../../utils/date";
import { useNavigate } from "react-router-dom";

export const MigratedLadderFLow = () => {
  const [currentTab, setCurrentTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [offerHeading, setOfferHeading] = useState("");
  const [offerSubHeading, setOfferSubHeading] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [fieldsDisabled, setfieldsDisabled] = useState(false);
  const navigator = useNavigate();
  const userstate = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [tabsData, setTabsData] = useState([
    "User details",
    "Password Generation",
    "Review",
  ]);

  const [passwordSuccess, setPasswordSuccess] = useState(false);

  const checkFormFieldsValidation = () => {
    console.log("brandStatenew", userstate);
    const mandatoryFields = document.getElementsByClassName("mandatory");
    let allFieldCaptured = true;
    let firstValidationField;

    console.log("Starting form validation"); // Log to indicate start of validation
    console.log(`Total mandatory fields: ${mandatoryFields.length}`);

    for (let i = 0; mandatoryFields.length > i; i++) {
      const field = mandatoryFields[i];
      console.log(
        `Checking field: ${field.name || field.id || "Unnamed Field"}`
      );

      // Check if the field is empty or a 'Select' dropdown
      if (field.value == "" && field.id !== "phoneNumber") {
        console.log(`Field is empty or "Select": ${field.name || field.id}`);

        const tempSpan = document.createElement("span");
        tempSpan.classList.add("validation-error");
        tempSpan.innerHTML = `${
          field.value == "Select" ? "Please select" : "Please enter"
        } ${field.ariaValueNow || "this field"}`;

        // Check if error message already exists for the field
        if (
          !field?.nextElementSibling?.classList.contains("validation-error")
        ) {
          console.log("Inserting error message");
          field.insertAdjacentElement("afterend", tempSpan);
          field.addEventListener("change", () => {
            console.log(
              `Field changed, removing validation error: ${
                field.name || field.id
              }`
            );
            tempSpan?.remove();
          });
        }

        if (allFieldCaptured) {
          firstValidationField = field;
        }
        allFieldCaptured = false;
      }

      // Check for email validation
      if (
        field.value !== "" &&
        field.type == "email" &&
        !isEmail(field.value)
      ) {
        console.log(`Invalid email in field: ${field.name || field.id}`);

        const tempSpan = document.createElement("span");
        tempSpan.classList.add("validation-error");
        tempSpan.innerHTML = `Please enter a valid email`;

        // Check if error message already exists for the field
        if (
          !field?.nextElementSibling?.classList.contains("validation-error")
        ) {
          console.log("Inserting email validation error message");
          field.insertAdjacentElement("afterend", tempSpan);
          field.addEventListener("change", () => {
            console.log(
              `Field changed, removing validation error: ${
                field.name || field.id
              }`
            );
            tempSpan?.remove();
          });
        }

        if (allFieldCaptured) {
          firstValidationField = field;
        }
        allFieldCaptured = false;
      }
      console.log(
        "field.value",
        field.value,
        " field.type",
        field.type,
        "field.id",
        field.id,
        "isPhoneNumber(field.value)",
        isPhoneNumber(field.value)
      );
      if (
        field.id === "phoneNumber" &&
        !isPhoneNumber(field.value) // Assuming isPhoneNumber is a function that validates phone number
      ) {
        console.log(`Invalid phone number in field: ${field.name || field.id}`);

        const tempSpan = document.createElement("span");
        tempSpan.classList.add("validation-error");
        tempSpan.innerHTML = `Please enter a valid 10 digit phone number`;

        // Check if error message already exists for the field
        if (
          !field?.nextElementSibling?.classList.contains("validation-error")
        ) {
          console.log("Inserting phone number validation error message");
          field.insertAdjacentElement("afterend", tempSpan);
          field.addEventListener("change", () => {
            console.log(
              `Field changed, removing validation error: ${
                field.name || field.id
              }`
            );
            tempSpan?.remove();
          });
        }

        if (allFieldCaptured) {
          firstValidationField = field;
        }
        allFieldCaptured = false;
      }
    }

    // Final check for form validity
    console.log("Final form validation check");
    if (allFieldCaptured) {
      console.log("All fields are valid, submitting form");

      return setCurrentTab(2);
    }

    console.log("Validation failed, focusing on first invalid field");
    firstValidationField?.focus();
  };
  const redirectBack = () => {
    navigator("/");
  };

  const Close = () => {
    setOpenConfirmationModal(false);
  };

  const handleSubmit = async () => {
    console.log("userSTate", userstate);
    setIsLoading(true);
    showSpinner("Creating", "User creation is in progress.");
    // setDiableButtons(true)
    const response = await submitUserform(userstate);
    if (response?.status === 200 || response?.status === 201) {
      Swal.close();
      setOfferHeading("User has been created!");
      setOfferSubHeading("The User has been created successfully on");
      setIsLoading(false);
      setOpenConfirmationModal(true);
    } else {
      showMessage(
        "Something went wrong.",
        response?.data?.message ? response?.data?.message : "Please try again."
      );
      setIsLoading(false);
    }

    setIsLoading(false);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-12 px-0">
          <div className="left-title-bg">
            <p className="left-title">Partner Registration</p>
            {/* <p className="left-title">Step {currentTab}</p> */}
          </div>
          <div className="content ">
            <div className="mb-25 upper-icon">
              <a href="#">
                <img
                  src={getImageUrl("logo-dark.svg")}
                  alt="img"
                  className="w-200p"
                />
              </a>
            </div>

            <div className="wizard">
              <div className="wizard-inner">
                <FormsTabs
                  selectedTab={currentTab}
                  tabs={tabsData}
                  setCurrentTab={setCurrentTab}
                />
              </div>
              <div className="tab-content mt-4">
                <div
                  className={`tab-pane ${currentTab == 1 ? "active" : ""}`}
                  id="step1"
                >
                  <p className="mb-0 font-20 font-md-30 font-weight-800">
                    User Details
                  </p>
                  <p>Please Verify and enter your details below.</p>

                  <UserMigratedDetails
                    selectedTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    fieldsDisabled={fieldsDisabled}
                    setfieldsDisabled={setfieldsDisabled}
                  />

                  <div className="my-10 d-flex justify-content-start">
                    {!fieldsDisabled && (
                      <button
                        type="button"
                        dis
                        className="btn btn-default next-step px-30"
                        onClick={() => {
                          checkFormFieldsValidation();

                          // dispatch(onboardFormActions.updateDocuments(formData.domains));
                        }}
                      >
                        Next Step
                      </button>
                    )}
                  </div>
                </div>

                <div
                  className={`tab-pane ${currentTab == 2 ? "active" : ""}`}
                  id="step3"
                >
                  <p className="mb-0 font-20 font-md-30 font-weight-800">
                    Password Generation
                  </p>
                  <p>Please set up your new password.</p>
                  <PasswordVerification setCurrentTab={setCurrentTab} />
                </div>
                <div
                  className={`tab-pane ${currentTab == 3 ? "active" : ""}`}
                  id="step4"
                >
                  <p className="mb-0 font-20 font-md-30 font-weight-800">
                    Review
                  </p>
                  <p>Please Verify your details below.</p>
                  <ReviewDetailsForm
                    selectedTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    isLoading={isLoading}
                  />
                  <div className="my-40 mx-100">
                    <button
                      type="button"
                      disabled={isLoading}
                      class="btn btn-default  btn-block font-weight-600 rounded-12 py-10 mt-40 mb-4"
                      // onClick={() => HandleUserExists()}
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {isLoading ? "Updating..." : "Confirm details"}
                    </button>
                    <button
                      type="button"
                      disabled={isLoading}
                      className="btn btn-light btn-block font-weight-600 rounded-12 py-10 "
                      onClick={() => setCurrentTab(2)}
                    >
                      Back
                    </button>
                  </div>
                </div>
                <SuccessActionModal
                  show={openConfirmationModal}
                  heading={offerHeading}
                  btnText={"Okay"}
                  subHeading={offerSubHeading}
                  datedOn={formatDate(new Date())}
                  type={"warning"}
                  action={redirectBack}
                  submitText={"Initiating..."}
                  Close={Close}
                  imgString={"/approve.svg"}
                />
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="prvcypolcy">
        <p class="font-10">
          By using this service you agree to our
          <br />
          <span class="text-orange pointer mx-2">
            <a
              href="https://hayak-dev.dafz.ae/web/hayak/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              terms of service
            </a>
          </span>
          &
          <span class="text-orange pointer mx-2">
            <a
              href="https://hayak-dev.dafz.ae/web/hayak/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              privacy policy
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};
